// Module
var code = `<validator ng-if="\$ctrl.validate" condition="\$ctrl.validate()"></validator>
<div ng-class="\$ctrl.inactive ? 'multiselect inactive folded' : ((\$ctrl.showDropdown || \$ctrl.getUnfolded()) ? 'multiselect unfolded' : 'multiselect folded')">
  <div class="multiselect__chosen-option" ng-click="\$ctrl.showDropdown = !\$ctrl.showDropdown"
        ng-class="{'invalid': \$ctrl.ngModelCtrl.\$invalid || (\$ctrl.validate && !\$ctrl.validate())}">
    {{\$ctrl.renderLabel()}}
  </div>
  <div class="multiselect__options-wrapper" ng-show="\$ctrl.getUnfolded() || \$ctrl.showDropdown && !\$ctrl.inactive">
  <ul class="multiselect__options">
    <li class="multiselect__select-all" ng-if="\$ctrl.isSelectAllOption()">
      <input
        class="multiselect__checkbox"
        type="checkbox"
        ng-model="\$ctrl.selectAllSelected"
        ng-disabled="\$ctrl.ngDisabled"
        ng-click="\$ctrl.selectAllChange()"
        />
      <strong>Select All</strong>
    </li>
    <li class="multiselect__item" ng-repeat="item in \$ctrl.deepCopyItems track by item[\$ctrl.getValueProperty()]" >
        <input
          class="multiselect__checkbox"
          type="checkbox"
          ng-model="item.checked"
          ng-disabled="\$ctrl.ngDisabled"
          ng-click="\$ctrl.onCheckboxChange(); \$event.stopPropagation()"
        />{{item[\$ctrl.getLabelProperty()]}}
    </li>
  </ul>
</div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/multiselect/multiselect.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;